import React from 'react';
import { StatusBar } from 'expo-status-bar';
import { ErrorBoundary } from './src/components/ErrorBoundary';
import { WebAppWrapper } from './src/components/WebApp';
import { RootNavigator } from './src/navigation/RootNavigator';
import { AppProviders } from './src/providers/AppProviders';

export default function App() {
  return (
    <AppProviders>
      <ErrorBoundary>
        <WebAppWrapper>
          <RootNavigator />
        </WebAppWrapper>
        <StatusBar style='auto' />
      </ErrorBoundary>
    </AppProviders>
  );
}
